/** @format */

import React, { useEffect, useRef, useState } from "react";
import { Routes, Route, useSearchParams } from "react-router-dom";

//components
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Apply from "./pages/ApplyMain";
import ApplyIntro from "./pages/ApplyIntro";
import Navbar from "./components/Navbar/Navbar";
import ApplyIntroDates from "./pages/ApplyIntroDates";
// import ApplySalesforce from "./pages/ApplySalesforce";
import CodingChallenge from "./pages/CodingChallenge";
import ApplyJavaScript from "./pages/ApplyJavaScript";
import LandingBootcamp from "./pages/LandingBootcamp";
import FrequentQuestions from "./pages/FrequentQuestions";
import IntroductoryCourse from "./pages/IntroductoryCourse";
import ApplyJavascriptDates from "./pages/ApplyJavascriptDates";
// import ApplySalesforceDates from "./pages/ApplySalesforceDates";

//styles
import AppTheme from "./styles/theme";

//i18n
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

//translations
import en from "../src/translations/en";
import es from "../src/translations/es";
import Footer from "./components/Footer/Footer";

import GoTopButton from "./components/Buttons/GoTopButton";
import { Box, keyframes, useMediaQuery } from "@mui/material";
import ApplyResult from "./pages/ApplyResult";
import Bootcamp from "./pages/Bootcamp";
import ApplyForm from "./pages/ApplyForm";
import NotFound from "./pages/404Page";

i18n.use(initReactI18next).init({
  resources: {
    es: {
      translation: es,
    },
    en: {
      translation: en,
    },
  },
  lng: localStorage.getItem("lang") ? localStorage.getItem("lang") : "es",
  fallbackLng: "es",

  interpolation: {
    escapeValue: false,
  },
});

const showUp = keyframes`
from {
  opacity: 0;
} to {
  opacity: 1;
}
`;

const useStyles = () => ({
  container: {
    maxHeight: "100vh",
    overflowY: "scroll",
    position: "relative",
    "&::-webkit-scrollbar": {
      width: { xs: 0, md: "16px", lg: "16px", xl: "16px" },
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#f4f4f4",
    },
    "&::-webkit-scrollbar-track:hover": {
      backgroundColor: "#f4f4f4",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#babac0",
      borderRadius: "16px",
      border: "5px solid #fff",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#a0a0a5",
      border: "4px solid #f4f4f4",
    },
    "&::-webkit-scrollbar-button": { display: "none" },
  },
  goTopButton: {
    animation: `${showUp} 0.25s ease-in-out forwards`,
    position: "fixed",
    top: "32px",
    pr: { md: "16px", lg: "16px", xl: "16px" },
    right: "0px",
    zIndex: 100,
  },
});

const App = () => {
  const containerRef = useRef(null);
  const [headerIsVisible, setHeaderIsVisible] = useState(true);
  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const [searchParams] = useSearchParams();
  const lsUtmSource = localStorage.getItem("utm_source");

  useEffect(() => {
    const utmSource =
      searchParams.get("utm_source") ||
      (searchParams.get("gclid") && "Google") ||
      "Orgánico";
    if (!lsUtmSource) {
      localStorage.setItem("utm_source", utmSource);
    }
  }, [lsUtmSource, searchParams]);

  useEffect(() => {
    if (containerRef.current) {
      const container = containerRef.current;

      const handleScroll = () =>
        setHeaderIsVisible(
          isMobile ? container.scrollTop <= 64 : container.scrollTop <= 128
        );

      if (container) {
        container.addEventListener("scroll", handleScroll);
      }

      return () => container.removeEventListener("scroll", handleScroll);
    }
  }, [isMobile]);

  return (
    <AppTheme>
      <Box sx={classes.container} ref={containerRef}>
        <Navbar />
        {!headerIsVisible && (
          <GoTopButton
            sx={classes.goTopButton}
            onClick={() =>
              containerRef.current.scroll({ top: 0, behavior: "smooth" })
            }
          />
        )}
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/challenge" element={<CodingChallenge />} />
          <Route exact path="/bootcamp" element={<LandingBootcamp />} />
          <Route path="/bootcamp/:type" element={<Bootcamp />} />
          <Route exact path="/intro" element={<IntroductoryCourse />} />
          <Route exact path="/faqs" element={<FrequentQuestions />} />
          <Route exact path="/nosotros" element={<AboutUs />} />
          <Route exact path="/aplica" element={<Apply />} />
          <Route
            exact
            path="/aplica/javascript"
            element={<ApplyJavaScript />}
          />
          {/* <Route
            exact
            path="/aplica/salesforce"
            element={<ApplySalesforce />}
          /> */}
          <Route exact path="/aplica/intro" element={<ApplyIntro />} />
          <Route
            exact
            path="/aplica/intro/fechas"
            element={<ApplyIntroDates />}
          />
          <Route
            exact
            path="/aplica/javascript/fechas"
            element={<ApplyJavascriptDates />}
          />
          {/* <Route
            exact
            path="/aplica/salesforce/fechas"
            element={<ApplySalesforceDates />}
          /> */}
          <Route
            exact
            path="/aplica/:course/formulario"
            element={<ApplyForm />}
          />
          <Route exact path="/aplicar/payment" element={<ApplyResult />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </Box>
    </AppTheme>
  );
};

export default App;
